import { useTranslation } from 'react-i18next';
import { useSession } from '../../state/session.tsx';
import { EmptyState } from '../../components/ui.tsx';
import ManagedSmsNumberSection from '../../components/managed-sms-number-section.tsx';
import SmsSettingsSection from '../../components/sms-settings-section.tsx';
import OwnTextingRegistrationCard from '../../components/settings/own-texting-registration-card.tsx';
import { SettingsLeafPage } from '../../components/settings/settings-leaf-page.tsx';

/**
 * Settings › Texting & calls › Texting setup: the managed number, the owner's
 * own Twilio account (Connect or pasted credentials, and the number bought in
 * it), the A2P / Trust Hub registration, and the texting policy. Kept apart
 * from calls and job chat so the compliance forms never sit between someone
 * and an everyday switch. Below the plan, the SMS card is the upgrade note.
 */
export default function TextingSettingsPage() {
  const { t } = useTranslation();
  const { can } = useSession();
  return (
    <SettingsLeafPage
      title={t('settings.messagingPages.tiles.texting.title')}
      back={{ to: '/settings/messaging', label: t('settings.messagingPages.backToMessaging') }}
    >
      {can('company:write') ? (
        <>
          <ManagedSmsNumberSection />
          <SmsSettingsSection />
          <OwnTextingRegistrationCard />
        </>
      ) : (
        <EmptyState title={t('settings.messagingPages.noAccess')} />
      )}
    </SettingsLeafPage>
  );
}
